import React, { Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { CSpinner, useColorModes } from '@coreui/react'


import './scss/style.scss'
// We use those styles to show code examples, you should remove them in your application.
import './scss/examples.scss'


//React.lazy() fonksiyonu, bileşenleri gerektiğinde (ihtiyaç duyulunca) yüklemek
// için kullanılır. Bu, uygulamanın başlangıçta yüklenme süresini
// azaltmak için faydalıdır.
//Büyük uygulamalarda tüm bileşenleri baştan yüklemek yerine sadece
// kullanıcı görmeden önce yüklemek performansı artırır.
//() => import('./layout/DefaultLayout') nedir?
// Bu bir dinamik import ifadesidir. Şunu yapar:
//./layout/DefaultLayout.js dosyasını asenkron (dinamik) olarak yükler.
// Webpack bu dosyayı ayrı bir chunk (parça dosya) olarak derler.
// Yani uygulama açıldığında bu dosya yüklenmez. Sadece bu bileşen DOM'da
// kullanıldığında ağ üzerinden (veya diskten) yüklenir.
// Containers
const DefaultLayout = React.lazy(() => import('./layouts/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))



const App = () => {
    //Bu satır, büyük ihtimalle CoreUI temasının sunduğu özel bir React Hook'u kullanıyor.
    // useColorModes(...) fonksiyonu, verilen tema adını kullanarak mevcut renk modunu
    // (örneğin: light, dark, auto) kontrol etmenizi ve değiştirmenizi sağlar.
    // Parametre olarak 'coreui-free-react-admin-template-theme' adında bir tema profili verilmiş.
    //isColorModeSet
    //Renk modunun belirlenip belirlenmediğini kontrol eden bir değişken (veya fonksiyon).
    //Örneğin: true ise tema daha önceden bir yerde ayarlanmış anlamına gelir.
    //➤ setColorMode
    //Renk modunu ayarlamak için kullanılan bir fonksiyon.
    //Örnek kullanım: setColorMode('dark') veya setColorMode('light').
    const { isColorModeSet, setColorMode } = useColorModes('coreui-free-react-admin-template-theme')


    //Bu satırda useSelector adlı hook, Redux'tan alınır ve global state içinden theme (tema bilgisi) alanını alır.
    //state.theme, Redux store içinde tanımlanmış bir tema bilgisini temsil eder.
    // Örneğin: "dark", "light" ya da "auto" gibi.
    //➤ storedTheme
    //Bu değişken, Redux store’da daha önce kaydedilmiş olan tema modunu içerir.
    const storedTheme = useSelector((state) => state.theme)



    return (
        //HashRouter:
        //React Router'ın bir bileşenidir. URL'lerde # karakterini kullanarak sayfa yönlendirmesi yapar. Örneğin: http://site.com/#/home.
        // Bu, sunucu yapılandırmasına ihtiyaç duyulmadan client-side routing sağlar.
        <HashRouter>
            {/*
            Suspense:
            React’in tembel (lazy) yüklenen bileşenler için sunduğu bir özelliktir.
            React.lazy ile yüklenen bileşenler yüklenene kadar burada tanımlanan fallback gösterilir.
            */}
            <Suspense
                //fallback: Yükleme süresince ne gösterileceğini belirtir.
                //Burada pt-3 (padding-top: 3) ve text-center (ortalanmış yazı)
                //sınıflarıyla stil verilmiş bir div içinde mavi bir CSpinner gösteriliyor.
                fallback={
                    <div className="pt-3 text-center">
                        <CSpinner color="primary" variant="grow" />
                    </div>
                }
            >
                {/*
                <Routes>:
                React Router v6 ile birlikte gelen yeni yönlendirme sistemi içinde kullanılan bir kapsayıcı
                bileşendir. İçine <Route> bileşenleri yerleştirilir. Eski versiyonlardaki <Switch> bileşeninin yerini
                almıştır.
                */}
                <Routes>
                    {/*
                    Eğer kullanıcı tarayıcıda /login adresine giderse, Login.js dosyasındaki Login bileşenini göster.
                    */}
                    <Route exact path="/login" name="Login Page" element={<Login />} />
                    <Route exact path="/register" name="Register Page" element={<Register />} />
                    <Route exact path="/404" name="Page 404" element={<Page404 />} />
                    <Route exact path="/500" name="Page 500" element={<Page500 />} />
                    {/*
                    <Route path="*":
                    path="*" ifadesi, tüm URL'leri yakalamak için kullanılır.
                    Yani hangi rota yazılırsa yazılsın (/, /home, /abc, /herhangi-bir-sey), bu route çalışır.
                    Bu genellikle bir "catch-all" route olarak kullanılır.
                    Ya tüm trafiği belirli bir layout’a yönlendirmek ya da "404 Not Found"
                    gibi bir ekran göstermek için kullanılır.
                    name="Home":
                    Bu prop React Router 6’da resmi olarak kullanılmaz.
                    Muhtemelen geliştirici tarafından okunabilirlik ya da özel kullanım
                    (örneğin menü başlığı gibi) için eklenmiş bir custom prop’tur. Router bunu dikkate almaz.
                    element={<DefaultLayout />}:
                    path="*" ile eşleşen her rota için gösterilecek bileşen burasıdır.
                    */}
                    <Route path="*" name="Home" element={<DefaultLayout />} />
                </Routes>
            </Suspense>
        </HashRouter>
    )

}

export default App